module.exports = __webpack_public_path__ + "static/img/home_type_icon_jcbk.2700b4e8.webp";